import { render, staticRenderFns } from "./SideBarLayout.vue?vue&type=template&id=9663eaa4&scoped=true"
import script from "./SideBarLayout.vue?vue&type=script&lang=js"
export * from "./SideBarLayout.vue?vue&type=script&lang=js"
import style0 from "./SideBarLayout.vue?vue&type=style&index=0&id=9663eaa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9663eaa4",
  null
  
)

export default component.exports